import React from "react";
import Navbar from "./components/navbar";
import CreateEquismobileComponent from "./create/create.component";
import CreateEquismobileProvider from "./create/provider/createEquismobile.provider";
import CreateUsedEquismobileProvider from "./create/used/provider/createUsedEquismobile.provider";
import CreateNewsEquismobileProvider from "./create/news/provider/createNewsEquismobile.provider";

const EquismobilePage = () => {
  return (
    <CreateEquismobileProvider>
      <CreateNewsEquismobileProvider>
        <CreateUsedEquismobileProvider>
          <div className="h-screen overflow-auto bg-gradient-to-b from-white to-[#5FBE42]">
            <Navbar />
            <section className="flex h-full w-full items-center justify-center p-0">
              <div className="container mb-auto mt-auto w-full px-4 lg:px-20">
                <CreateEquismobileComponent />
              </div>
            </section>
          </div>
        </CreateUsedEquismobileProvider>
      </CreateNewsEquismobileProvider>
    </CreateEquismobileProvider>
  );
};

export default EquismobilePage;
